export default __webpack_public_path__ + "static/media/axion-logo.e26e6786.png";